import React from 'react';
import PropTypes from 'prop-types';

import { BreedSearchResultPropTypes } from 'dpl/shared/utils/customPropTypes';
import { FancyDropdownMenu } from 'dpl/components/FancyDropdown';
import LoadingWrapper from 'dpl/components/LoadingWrapper';

import BreedSearchResultsListV2 from './BreedSearchResultsListV2';
import { BREED_PROFILES, BREED_TYPES } from '../util';

export default function BreedSearchResults({
  breeds,
  query,
  breedType,
  isLoading,
  onSelectItem,
  maxHeight
}) {
  return (
    <FancyDropdownMenu
      maxHeight={maxHeight}
      className="BreedSearchResults dropdown-box-shadow overflow-y-auto br3 mt4"
      contentClassName="pv2"
    >
      <LoadingWrapper isLoading={isLoading}>
        <BreedSearchResultsListV2
          inDropdown
          breeds={breeds}
          query={query}
          breedType={breedType}
          onSelectItem={onSelectItem}
        />
      </LoadingWrapper>
    </FancyDropdownMenu>
  );
}

BreedSearchResults.propTypes = {
  query: PropTypes.string.isRequired,
  breeds: PropTypes.arrayOf(PropTypes.shape(BreedSearchResultPropTypes))
    .isRequired,
  breedType: PropTypes.oneOf([BREED_TYPES.ALL, BREED_PROFILES]),
  isLoading: PropTypes.bool.isRequired,
  onSelectItem: PropTypes.func,
  maxHeight: PropTypes.string
};

BreedSearchResults.defaultProps = {
  breedType: null,
  onSelectItem: null,
  maxHeight: null
};
